export default __webpack_public_path__ + "490656b7a2c6e5ce8eb87271bc6ea90d.png";